import { render, staticRenderFns } from "./from0tohero1.vue?vue&type=template&id=bcd6b27a&"
import script from "./from0tohero1.vue?vue&type=script&lang=js&"
export * from "./from0tohero1.vue?vue&type=script&lang=js&"
import style0 from "./from0tohero1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports